import { IconProps } from "./types";

const AiSparkleIcon = ({ size }: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 15 15"
    fill="currentColor"
    stroke="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2312_38499)">
      <path d="M13.0533 6.13117C10.2967 6.13117 8.06221 3.89636 8.06221 1.14004V0H5.93814V1.13969C5.93814 3.89636 3.70332 6.13083 0.947002 6.13083H0V7.86883H0.94666C3.70332 7.86883 5.93779 10.1036 5.93779 12.86V13.9997H8.06186V12.86C8.06186 10.1033 10.2967 7.86883 13.053 7.86883H13.9997V6.13083H13.053L13.0533 6.13117Z" />
      <path d="M3.82092 1.79457C3.01416 1.79457 2.35996 1.14038 2.35996 0.333611V0H1.73834V0.333611C1.73834 1.14038 1.08415 1.79457 0.27738 1.79457H0V2.30339H0.277038C1.08381 2.30339 1.738 2.95758 1.738 3.76435V4.09796H2.35962V3.76435C2.35962 2.95758 3.01381 2.30339 3.82058 2.30339H4.09762V1.79457H3.82058H3.82092Z" />
    </g>
    <defs>
      <clipPath id="clip0_2312_38499">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default AiSparkleIcon;
